<li class="nav-item">
    <button class="nav-link btn btn-success text-white mr-2" (click)="recoverFinished()"><i class="fa fa-recycle" aria-hidden="true"></i> {{ "recoverFinished" | language }}</button>
</li>